import React, { useState } from 'react'
import arrowAcorddion from '../../assets/arrow-acorddion.svg'
import { t } from 'i18next'
import ItemWithStatus from '../ItemSelectable/ItemWithStatus'
import { URL_EXACTIAN, getTenantInfoByKey, havePermission } from '../../helpers/helpers'
import isExceptedIcon from '../../assets/icons/isExcepted-icon.svg';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'
import { DocumentDueModal } from '../CreateAccess/DocumentDueModal'
import { ContractsDetailModal } from '../CreateAccess/ContractsDetailModal'

const EmployeeInfoCard = ({ employee }) => {

    const [showDetail, setShowDetail] = useState(false);

    const [showDocumentDueModal, setShowDocumentDueModal] = useState(false);

    const [showContractsDetailModal, setShowContractsDetailModal] = useState(false);

    const accessStatusOptions = {
        0: {
            color: '#00dea3',
            icon: 'fa-solid fa-circle-check',
            employeStatusLabel: t('APT'),
            contractorStatusLabel: t('APT'),
            label: t('ENABLED'),
        },
        1: {
            color: '#FFCC40',
            icon: 'fa-solid fa-circle-check',
            employeStatusLabel: t('APT_TO_ENTRY'),
            contractorStatusLabel: t('PART_APT'),
            label: t('ENABLED'),
        },
        2: {
            color: '#FA5A7C',
            icon: 'fa-solid fa-circle-xmark',
            employeStatusLabel: t('UN_APT_ENTRY'),
            contractorStatusLabel: t('UN_APT'),
            label: t('NOT_ENABLED'),
        }
    };

    const employeeGeneralStatus = employee.access_status ? accessStatusOptions[employee.access_status.employee_general_status] : null;

    const employeeStatus = employee.access_status ? accessStatusOptions[employee.access_status.employee_status] : null;

    const contratorStatus = (employee.access_status && employee.access_status.contractor_status) ? accessStatusOptions[employee.access_status.contractor_status] : null;

    const haveDueDocuments = employee.access_status ? employee.access_status?.contractor_status === 2 || employee.access_status?.employee_status === 2 || employee.access_status?.employee_general_status === 2 : false

    const contracts = employee?.access_status?.contracts;

    const havePermissionToSeeDueDocuments = havePermission(24);
    const havePermissionToSeeContractsDetail = havePermission(25);

    const mainContractorStatus = (status) => {
        return accessStatusOptions[status]
    }

    return (
        <>
            {showDocumentDueModal && (
                <DocumentDueModal
                    showModal={showDocumentDueModal}
                    setShowModal={() => setShowDocumentDueModal(!showDocumentDueModal)}
                    resourceDocumentsDue={employee.access_status?.employee_due_documents}
                    contractorDocumentsDue={getTenantInfoByKey('is_resource_affected_by_contractor') ? employee.access_status?.contractor_due_documents : []}
                    mainContractorsDocumentsDue={employee.access_status?.maincontractors_status}
                />
            )}

            {showContractsDetailModal && (
                <ContractsDetailModal
                    resource='EMP'
                    contracts={contracts}
                    showModal={showContractsDetailModal}
                    setShowModal={() => setShowContractsDetailModal(!showContractsDetailModal)}
                />
            )}

            <div className='white-bg w-100 pt-3 pb-2 rounded-3 shadow'>
                <div className="d-flex ps-4 pe-4 justify-content-between">
                    <div className='d-flex align-items-center gap-2'>
                        <img
                            style={{ width: '57px', height: '57px' }}
                            src={`${URL_EXACTIAN}Actions/img_proxy.php?idEMP=${employee.id}`}
                            alt=""
                        />
                        <div>
                            <h6 className='blue-text m-0'>{employee.fullname}</h6>
                            <span className='blue-dark-text-low-size'>{`${getTenantInfoByKey('employee_id_lbl')}: ${employee.natural_id}`}</span>
                        </div>
                    </div>
                    <div className='mt-2'>
                        {employee.access_status && !employee.access_status?.is_excepted && (
                            <i
                                className={employeeGeneralStatus ? employeeGeneralStatus.icon : ''}
                                style={{ color: employeeGeneralStatus ? employeeGeneralStatus.color : '' }}
                            >
                            </i>
                        )}

                        {employee.access_status && employee.access_status?.is_excepted && (
                            <>
                                <CustomTooltip placement={'top'} target={'is_excepted_img_icon'} text={t('EXCEPTED')} />
                                <img id='is_excepted_img_icon' src={isExceptedIcon} style={{ height: '20px' }} alt="Excepted Icon" />
                            </>
                        )}

                    </div>
                </div>
                {
                    showDetail ?
                        <div>
                            <div className='mt-2 pt-2 pb-2 ps-4 pe-4 border-bottom'>
                                {employee.access_status && (
                                    <div className='d-flex justify-content-between'>
                                        <div>
                                            <h6 className='m-0 subtitle'>{t('STATE')}</h6>
                                            <span
                                                className='blue-dark-text'
                                                style={{ color: employeeGeneralStatus ? employeeGeneralStatus.color : '' }}
                                            >
                                                {employeeGeneralStatus ? employeeGeneralStatus.label : ''}
                                            </span>
                                        </div>
                                        <div>
                                            <h6 className='m-0 subtitle'>{t('STATUS_DETAIL')}</h6>
                                            <div>
                                                <span className='blue-dark-text'>{employeeStatus ? employeeStatus.employeStatusLabel : ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className='mt-2'>
                                    <h6 className='m-0 subtitle'>{t('RANK')}</h6>
                                    <span className='blue-dark-text'>{employee.classifications}.</span>
                                </div>
                            </div>
                            <div className='ps-4 pe-4 mt-2 border-bottom'>
                                <ItemWithStatus
                                    statusColor={contratorStatus ? contratorStatus.color : ''}
                                    statusLabel={contratorStatus ? contratorStatus.contractorStatusLabel : ''}
                                >
                                    <h6 className='m-0 blue-dark-text fw-bold'>{employee.contractor_name}</h6>
                                    <span
                                        className='subtitle'
                                    >
                                        {t('CONT')}
                                    </span>
                                </ItemWithStatus>
                                {employee.access_status && (
                                    employee.access_status.maincontractors_status.map((mainContractor, idx) =>
                                        <ItemWithStatus
                                            key={idx}
                                            statusColor={mainContractor.status ? mainContractorStatus(mainContractor.status).color : ''}
                                            statusLabel={mainContractor.status ? mainContractorStatus(mainContractor.status).contractorStatusLabel : ''}
                                        >
                                            <h6 className='m-0 blue-dark-text fw-bold'>{mainContractor.name}</h6>
                                            <span className='subtitle'>
                                                {t('CONT_MAIN')}
                                            </span>
                                        </ItemWithStatus>
                                    )
                                )}
                            </div>
                        </div>
                        :
                        null
                }
                <div className={`d-flex aling-items-center justify-content-${(havePermissionToSeeDueDocuments && haveDueDocuments) ? 'between' : 'end'} mt-1 ps-4 pe-4`}>
                    <div>
                        {(havePermissionToSeeDueDocuments && haveDueDocuments) && (
                            <div
                                type='button'
                                onClick={() => setShowDocumentDueModal(!showDocumentDueModal)}
                            >
                                <span
                                    className='blue-text'
                                    style={{ fontSize: '.8rem' }}
                                >
                                    {t('VIEW_DUE_DOC')}
                                </span>
                            </div>
                        )}

                        {(havePermissionToSeeContractsDetail) && (
                            <div
                                type='button'
                                onClick={() => setShowContractsDetailModal(!showContractsDetailModal)}
                            >
                                <span
                                    className='blue-text'
                                    style={{ fontSize: '.8rem' }}
                                >
                                    {t('SHOW_CONTRACTS_DETAILS')}
                                </span>
                            </div>
                        )}
                    </div>

                    <div
                        type='button'
                        onClick={() => setShowDetail(!showDetail)}
                    >
                        <img src={arrowAcorddion} alt="" style={{ transform: `rotate(${showDetail ? '180' : '0'}deg)` }} />
                    </div>
                </div>
            </div >
        </>
    )
}

export default EmployeeInfoCard